import { ActionButton } from '@/components/ZonesManagementRevamped/styles';
import { abyssColors } from '@/theme/colors';
import { styled as muiStyled } from '@mui/material';

type ButtonProps = {
  contained?: boolean;
  isError?: boolean;
  isWarning?: boolean;
};

export const StageActionButton = muiStyled(ActionButton)(
  ({ contained, isError, isWarning }: ButtonProps) => ({
    background:
      contained && isError
        ? abyssColors.error[600]
        : contained && isWarning
          ? abyssColors.warning[500]
          : abyssColors.success[500],
    padding: '0 0.8rem',
    height: '2.6rem',
    fontSize: '1.2rem',
    '&:disabled': {
      background: contained ? abyssColors.neutral[400] : abyssColors.neutral[50],
    },
    '&:hover': {
      background:
        contained && !isError && !isWarning
          ? abyssColors.success[400]
          : contained && isWarning
            ? abyssColors.warning[400]
            : contained && isError
              ? abyssColors.error[500]
              : abyssColors.neutral[50],
    },
  })
);

export const iconStyles = {
  height: '1.6rem',
  width: '1.6rem',
};
